import React, { useState, useRef } from 'react';
import { Box, Grid, InputBase, Button, Typography } from '@mui/material';
import { SearchOutlinedIcon, KeyboardArrowDownOutlinedIcon } from 'icons/materialIcons';
import TeamV2MemberAddModal from './TeamV2MemberAddModal';

const TeamV2MembersNavbar = ({ onSearch, membersCount = 200, onAddMemberSelect }) => {
    const [isAddMemberModalOpen, setIsAddMemberModalOpen] = useState(false);
    const addButtonRef = useRef(null);

    const handleAddMemberModalOpen = (event) => {
        addButtonRef.current = event.currentTarget;
        setIsAddMemberModalOpen(true);
    };

    const handleAddMemberModalClose = () => {
        setIsAddMemberModalOpen(false);
    };

    const handleAddMemberSelect = (option) => {
        setIsAddMemberModalOpen(false);
        if (onAddMemberSelect) {
            onAddMemberSelect(option);
        }
    };


    const handleSearchChange = (event) => {
        onSearch(event.target.value);
    };

    return (
        <Box sx={{ padding: '1rem' }}>
            <Grid container spacing={2} alignItems="center">
                {/* Left Side */}
                <Grid item xs={12} sm="auto">
                    <Grid container alignItems="center" spacing={1}>
                        <Grid item>
                            <Typography variant="h6" sx={{ fontWeight: 500 }}>
                                Members{' '}
                                <Typography component="span" variant="body2" sx={{ fontWeight: 400, color: '#757575' }}>
                                    ({membersCount})
                                </Typography>
                            </Typography>
                        </Grid>

                    </Grid>
                </Grid>

                {/* Right Side */}
                <Grid item xs={12} sm container justifyContent="flex-end" spacing={2}>
                    <Grid item xs="auto" sm="auto">
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: '#ffff',
                                borderRadius: '0.5rem',
                                padding: '0.25rem 1rem',
                                // border removed per request
                                width: 'fit-content',
                            }}
                        >
                            <SearchOutlinedIcon sx={{ color: '#757575', marginRight: 1 }} />
                            <InputBase
                                placeholder="Search..."
                                sx={{ width: { xs: 180, sm: 260 } }}
                                onChange={handleSearchChange}
                            />
                        </Box>
                    </Grid>
                    <Grid item>
                        <Button
                            ref={addButtonRef}
                            variant="contained"
                            onClick={handleAddMemberModalOpen}
                            sx={{
                                backgroundColor: '#000',
                                color: '#fff',
                                fontWeight: '500',
                                borderRadius: '0.5rem',
                                textTransform: 'none',
                                '&:hover': {
                                    backgroundColor: '#333',
                                },
                                display: 'flex',
                                alignItems: 'center',
                            }}
                            endIcon={<KeyboardArrowDownOutlinedIcon />}
                        >
                            Add Members
                        </Button>
                    </Grid>
                </Grid>
            </Grid>

            <TeamV2MemberAddModal
                isOpen={isAddMemberModalOpen}
                onClose={handleAddMemberModalClose}
                onSelect={handleAddMemberSelect}
                anchorEl={addButtonRef.current}
            />
        </Box>
    );
};

export default TeamV2MembersNavbar;
